import React, { useState } from 'react'

import {Button, Paper} from '@mui/material'

import useStyles from './styles.js'
import MatchPopupCreator from './popup/MatchPopupCreator.js';
import { useDispatch } from 'react-redux';
import { createMatch } from '../../../actions/matchs.js';
import { getUserProvider, isAdminDSAS  } from '../../../actions/auth.js';
import SelectGroupProvider from '../../../dsasComponents/SelectGroupProvider.js'

let initialMatchData = {
  competition : '',
  season : '',
  day : '',
  dateTime : new Date(),
  homeTeam : '',
  homeComposition : '',
  homeHolders : [],
  homeSubstitutes : [{}, {},{}, {}, {}],
  awayTeam : '',
  awayComposition : '',
  awayHolders : [],
  awaySubstitutes : [{}, {},{}, {}, {}],

  provider : getUserProvider()
}
const FormMatch = () => {
    const classes = useStyles();

    const dispatch = useDispatch()

    const [open, setOpen] = useState(false);

    const [stepInfos, setStepInfos] = React.useState(
      { data : initialMatchData, isComplete : [false]}
    )

    const handleClickOpen = () => {
        setOpen(true);
      };
    
    const handleClose = () => {
      setOpen(false);
    };

    const handleConfirm = () => {
      // On veut sauvegarder le match dans son état
      dispatch(createMatch(stepInfos.data))

      setStepInfos({ data : initialMatchData, isComplete : [false, false, false]})

      handleClose()
    }

    const handleCancel = () => {
      setOpen(false);

      setStepInfos({ data : initialMatchData, isComplete : [false, false, false]})
    }

    return (
        <Paper className={classes.paper}>
                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" onClick={handleClickOpen} fullWidth> Créer un nouveau match </Button>

                <MatchPopupCreator 
                  open={open} 
                  setOpen={setOpen}
                  handleConfirm={handleConfirm}
                  handleCancel={handleCancel}
                  stepInfos={stepInfos} 
                  setStepInfos={setStepInfos}/>
        </Paper>
    )
}

export default FormMatch